import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    btnTAContainer: {
        position: 'relative',
        height: '50px',
        marginBottom: '20px',
        [theme.breakpoints.down('xs')]: {
            height: '40px',
        }
    },
}), {
    name: 'ButtonTakeAssessmentHeadContainer',
    index: 1,
})

export default useStyles;